import { render, staticRenderFns } from "./IvControlPanel.vue?vue&type=template&id=ea2ea28e&scoped=true&"
import script from "./IvControlPanel.vue?vue&type=script&lang=js&"
export * from "./IvControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./IvControlPanel.vue?vue&type=style&index=0&id=ea2ea28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2ea28e",
  null
  
)

export default component.exports